import { __awaiter } from "tslib";
import { RcsbAnnotationConstants } from "../../../../RcsbAnnotationConfig/RcsbAnnotationConstants";
import { ExperimentalAlignmentTrackTitleFactory } from "./ExperimentalAlignmentTrackTitleFactory";
export class ModelAlignmentTrackTitleFactory {
    constructor(entityInstanceTranslator) {
        this.alignmentTrackTitleFactory = new ExperimentalAlignmentTrackTitleFactory(entityInstanceTranslator);
    }
    getTrackTitle(alignmentQueryContext, targetAlignment) {
        return __awaiter(this, void 0, void 0, function* () {
            const rowTitle = yield this.alignmentTrackTitleFactory.getTrackTitle(alignmentQueryContext, targetAlignment);
            return typeof rowTitle === "string" ? rowTitle : Object.assign(Object.assign({}, rowTitle), { style: {
                    fontWeight: "bold",
                    color: RcsbAnnotationConstants.provenanceColorCode.rcsbLink
                } });
        });
    }
    getTrackTitlePrefix(alignmentQueryContext, targetAlignment) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.alignmentTrackTitleFactory.getTrackTitlePrefix(alignmentQueryContext, targetAlignment);
        });
    }
    getTrackTitleFlagColor(alignmentQueryContext, targetAlignment) {
        return __awaiter(this, void 0, void 0, function* () {
            return RcsbAnnotationConstants.provenanceColorCode.csm;
        });
    }
}
//# sourceMappingURL=ModelAlignmentTrackTitleFactory.js.map